import React, { type CSSProperties, type ReactNode } from 'react';
import styled from 'styled-components';

export type HorizontalScrollContainerProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  'aria-busy'?: boolean;
};

export const HorizontalScrollContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  background: white;
  //  fix overflow hidden cropping the focus border

  @media (min-width: 768px) {
    padding: 0;
    margin-left: -4px;
    padding-left: 4px;
  }

  @media (max-width: 767px) {
    padding: 0 16px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const HorizontalScrollContainer = ({
  children,
  className,
  style,
  'aria-busy': ariaBusy,
}: HorizontalScrollContainerProps) => (
  <HorizontalScrollContainerStyled className={className} style={style} aria-busy={ariaBusy}>
    {children}
  </HorizontalScrollContainerStyled>
);

export default HorizontalScrollContainer;
